// extracted by mini-css-extract-plugin
module.exports = {"search":"helpCenterSearchBlock_search__a2gko","title":"helpCenterSearchBlock_title__U1hq6","searchBox":"helpCenterSearchBlock_searchBox__LuecP"};